export class InvoiceLineUsageRow {
  public timestamp: Date;
  public bNumber: string;
  public sourceNetwork: string;
  public sourceCountryCode: string;
  public serviceDescription: string;
  public duration: string;
  public sumWoVat: number;
  public destinationNetwork: string;
  public destinationCountryCode: string;
  public volume: string;
}
